import PropTypes from 'prop-types'

import withMemo from '../../../../../utils/withMemo'
import ProductCard from '../../../Product/ProductCard'
import ProductCardCtas from '../../../Product/ProductCtas/ProductCardCtas'

const ProductCategoryGridItem = ({
  category,
  product,
  position,
  onProductClick,
  onProductVisible,
}) => (
  <ProductCard
    category={category}
    product={product}
    onProductClick={onProductClick}
    onProductVisible={onProductVisible}
  >
    <ProductCardCtas position={position} productId={product.id} gridCardMode />
  </ProductCard>
)

ProductCategoryGridItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    mediaType: PropTypes.string,
  }),
  category: PropTypes.string,
  position: PropTypes.number,
  onProductClick: PropTypes.func,
  onProductVisible: PropTypes.func,
}

ProductCategoryGridItem.defaultProps = {
  product: null,
  category: '',
  position: 0,
  onProductClick: () => false,
  onProductVisible: () => false,
}

export default withMemo(
  ProductCategoryGridItem,
  ['product', 'category'],
)
